// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2dY9w","colMin":"styles_colMin__1N2_i","colCheckbox":"styles_colCheckbox__1SLYo"};